// extracted by mini-css-extract-plugin
export default {"menu":"CustomizedStatusSelect_menu__Wztze","showOptions":"CustomizedStatusSelect_showOptions__jiXp5"};